<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Groups</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Group
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <div class="row">
          <div class="col">
            <v-text-field
              id="name"
              v-model="selectedObj.Name"
              label="Group Name*"
              required
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              id="description"
              v-model="selectedObj.Description"
              label="Group Description"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-card>
              <div class="row">
                <div class="col-5 ml-5">
                  <v-text-field
                    id="searchUser"
                    v-model="SearchUser"
                    label="Search"
                    append-outer-icon="mdi-table-search"
                    @click:append-outer="onUserSearch"
                    v-on:keyup.enter="onUserSearch"
                  ></v-text-field>
                </div>
                <div class="col-6"></div>
              </div>
              <v-divider></v-divider>
              <div style="height: 550px; overflow-y: scroll">
                <v-data-table
                  :headers="userHeaders"
                  :items="users"
                  item-key="id"
                  hide-default-footer
                >
                  <template v-slot:item.id="{ item }">
                    <v-simple-checkbox
                      id="selected"
                      v-model="item.IsSelected"
                      @click="onSelect(item)"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </div>
              <Pagination
                  :paging="paging_users"
                  v-on:next="onNextPageUsers"
                />
            </v-card>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="float-right">
              <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
              <v-btn
                id="btnNew"
                class="mr-4"
                color="primary"
                @click="onSave()"
                :loading="loading"
                :disabled="loading"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left"></th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.Name }}  </td>
                  <td>{{ item.Description }}</td>
                  <td></td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination
            :paging="paging_groups"
            v-on:next="onNextPageCollection"
          />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import lodash from "lodash";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "OrgGroups",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination
  },
  created() {
    //this.getUsers(0);
    this. getUserGroups();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    /*
    resultQuery() {
      this.paging_users.keyword = this.SearchUser;
      if (this.SearchUser) {
        return this.users.filter(item => {
          return this.SearchUser.toLowerCase()
            .split(" ")
            .every(
              v =>
                item.firstName.toLowerCase().includes(v) ||
                item.lastName.toLowerCase().includes(v)
            );
        });
      } else {
        return this.users;
      }
    } */
  },
  methods: {
    onSearch() {
      this.paging_groups.page = 1;
      this.paging_groups.keyword = this.Search;
      this.getUserGroups();
    },
    onUserSearch() {
      console.log("onUserSearch");
      this.paging_users.page = 1;
      this.paging_users.keyword = this.SearchUser;
      this.getUsers(this.selectedObj.id);
    },
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.users = [];
      this.notify.type = 0;

      this.paging_users.page = 1;
      this.getUsers(0);

      this.selectedUserIds = [];
      this.loading=false;
    },
    onSave() {
      console.log(this.selectedObj);
      this.notify.type = 0;
      this.notify.errors = [];

/*
      var selectedUsers = this.users.filter(obj => {
        return obj.IsSelected == true;
      });

      let selectedUserIds = lodash.map(selectedUsers, function(pub) {
        return { id: pub.id };
      });
      console.log("IsSelected userids for Save");
      console.log(selectedUserIds);
      */

      this.selectedObj.users = this.selectedUserIds;

      if (this.selectedObj.Name == "") {
        this.notify.type = 4;
        this.notify.errors.push("Please enter group name.");
        return;
      }
      if (this.selectedObj.users.length == 0) {
          this.notify.type = 4;
          this.notify.errors.push("Please select at least one user.");
          return;
      }

      this.loading = true;
      new Promise((resolve, reject) => {
        api
          .update("organization-group", this.selectedObj)
          .then(response => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
             // this.getUserGroupByPagin();
              this.getUserGroups();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
          })
          .catch(error => {
             if (error.message == "Request failed with status code 409") {
                this.notify.type = 4;
                this.notify.errors.push("Group name already exist.");
                this.loading = false;
                reject(error);
              }
              else{
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data. " + error);
                this.loading = false;
                reject(error);
              }
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      console.log(this.selectedObj)
       this.selectedUserIds = []

      if(this.selectedObj.users != undefined)
      {
        for (let i = 0; i < this.selectedObj.users.length; i++) {
            this.selectedUserIds.push(this.selectedObj.users[i]);
        };
      }
      this.getUsers(obj.id);
    },
    async onDelete(obj) {
      let that = this;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization-group", obj.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                that.getUserGroups();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
      this.notify.errors = [];
    },
    getUsers(id) {
      let that = this;
      that.users.splice(0, that.users.length);
      new Promise((resolve, reject) => {
        api
          .getByPaginById("organization-group/users", id, this.paging_users)
          .then(response => {
            resolve(response);
            if (
              response.data != null &&
              response.data.data != null &&
              response.data.data.length > 0
            ) {
              that.users = []
              this.paging_users.count = response.data.count;
              response.data.data.forEach(e => {
                that.users.push({
                  id: e.id,
                  IsSelected: e.IsSelected == 1 ? true : false,
                  FirstName: e.firstName,
                  LastName: e.lastName,
                  Email: e.email,
                  users : e.users
                });
              });
              this.verifySelectedItems();
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUserGroups() {
      let that = this;
      that.overlay = true
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization-group", this.paging_groups)
          .then(response => {
            console.log("organization-group");
            console.log(response);
            that.list.splice(0, that.list.length);
            if (
              response.data != null &&
              response.data.data != null &&
              response.data.data.length > 0
            ) {
              this.paging_groups.count = response.data.count;
              response.data.data.forEach(e => {
                that.list.push({
                  id: e.id,
                  Name: e.Name,
                  Description: e.Description,
                  users : e.users
                });
              });
            }
            resolve(response);
            that.overlay = false
          })
          .catch(error => {
            reject(error);
            that.overlay = false
          });
      });
    },
    getUserGroupByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-group", this.paging)
          .then(response => {
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUserUserGroups(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("user-user-group/users", id)
          .then(response => {
            resolve(response);
            /*
            for (let i = 0; i < response.data.length; i++) {
              this.selectedObj.users.push(response.data[i]);
            }*/

            for (let i = 0; i < response.data.length; i++) {
              var objIndex = this.users.findIndex(
                p => p.id == response.data[i].id
              );
              this.users[objIndex].IsSelected = true;
            }
            this.SearchUser = " ";
            this.SearchUser = "";
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onChangeUsers(items) {
      for (let i = 0; i < items.length; i++) {
        if (!(typeof this.selectedObj.users[i] === "object")) {
          items.splice(i, 1);
          break;
        }
      }
    },
    onNextPageCollection(page) {
      this.paging_collection.page = page;
      this.getUserGroups();
    },
    onNextPageUsers(page) {
      this.paging_users.page = page;
      this.getUsers(this.selectedObj.id);
    },
    onSelect(item)
    {
      var found = this.selectedUserIds.filter(p => p.id==item.id)
       console.log(' found ' + found)

      if(found == undefined || found.length==0)
          this.selectedUserIds.push({ id : item.id })
      else 
      {
          for (var i = 0; i < this.selectedUserIds.length; i++) {
            if (this.selectedUserIds[i].id === item.id) 
            {
                this.selectedUserIds.splice(i, 1);
                break;
            }
          }
      }
    },
    verifySelectedItems()
    {
      console.log('verifySelectedItems')
        this.selectedUserIds.forEach(element => {
           var found = this.users.filter(p => p.id==element.id) 
           if(found != undefined && found.length > 0)
           {
              if(!found[0].IsSelected)
                  found[0].IsSelected = true;
           }
        });
    }
  },
  mounted() {
    //this.getUserGroups();
  },
  data() {
    return {
      list: [],
      users: [],
      isEdit: false,
      isNew: false,
      Search: "",
      SearchUser: "",
      selectedObj: {},
      selectedUsers: [],
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      loading: false,
      paging_groups: { count: 10, page: 1, size: 10, keyword: "" },
      paging_users: { count: 10, page: 1, size: 10, keyword: "" },
      selectedUserIds : [],
      userHeaders: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "Firstname",
          align: "start",
          sortable: false,
          value: "FirstName"
        },
        {
          text: "Lastname",
          align: "start",
          sortable: false,
          value: "LastName"
        },
        {
          text: "Email",
          align: "start",
          sortable: false,
          value: "Email"
        }
      ],
      overlay: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgUserGroups.vue